import { compose } from 'widgets-shared/core'
import { withComponentContext } from 'widgets-shared/core'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import React, { useState } from 'react'
import { Grid, Typography, Button } from '@mui/material'
import { withTranslations } from 'widgets-shared/core'
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { PropTranslations } from 'smartstream-widgets/types/widget'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'

const styles = (theme: Theme) => createStyles({

  backgroundCTAOfferDefault: {
    backgroundColor: "#E5E5EA"
  },
  backgroundCTAOfferTheme: {
    backgroundColor: theme.palette.background.surface1
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    color: theme.palette.text.primary,
    alignItems: 'center'
  },
  typographyStyle: {
    fontFamily: '-apple-system, BlinkMacSystemFont,"Segoe UI", "Roboto", "Oxygen","Ubuntu", "Cantarell", "Fira Sans","Droid Sans", "Helvetica Neue", sans-serif'
  },
  typography: {
    margin: 'auto',
    paddingLeft: 20,
    fontSize: 10,
  },
  typographyHideOffer: {
    margin: '0 8px',
    fontSize: 10,
    paddingRight: 30
  },
  removeIcon: {
    justifySelf: 'flex-end',
  },
  arrow: {
    color: theme.palette.primary.main,
    display: 'inline-block'
  },
  anchor: {
    color: theme.palette.primary.main,
    textDecorationColor: theme.palette.primary.main,
    fontWeight: 500
  },
  closeButton: {
    fontSize: 10,
    padding: 0,
    minWidth: 17,
    color: theme.palette.text.primary,
  },
  hideButton: {
    fontSize: 10,
    padding: 0,
    paddingRight: 4,
    minWidth: 35,
    textDecorationLine: 'underline',
    color: theme.palette.text.primary,
    fontWeight: 500
  },
  cancelButton: {
    fontSize: 10,
    padding: 0,
    color: theme.palette.primary.main,
    textDecorationColor: theme.palette.primary.main,
    textDecorationLine: 'underline',
    minWidth: 35,
    fontWeight: 500
  },
  rootButton: {
    textTransform: 'none',
    letterSpacing: 0
  },
  muiButtonLabel: {
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    width: '100%'
  }
})

type Props = {
  classes: {
    [K in string]: string
  },
  theme: Theme
  offerText: string,
  link: string,
  linkText: string,
  dismissibleOffer: boolean,
  showOfferText?: boolean,
  translations: PropTranslations,
  hideCtaOfferOnWidget?: (() => void),
  ctaOfferIsDisabledOnWidget: boolean
}

export const CTAOffer = (props: Props) => {
  const {
    classes,
    offerText,
    link,
    linkText,
    dismissibleOffer,
    showOfferText = true,
    translations,
    hideCtaOfferOnWidget,
    ctaOfferIsDisabledOnWidget,
    theme
  } = props


  const backgroundCTAOffer = theme.palette.background.surface1 ? classes.backgroundCTAOfferTheme : classes.backgroundCTAOfferDefault
  const [open, setOpen] = useState(false)
  const [showoffer, setshowOffer] = useState(showOfferText)

  const handleClick = (showOffer) => {
    setOpen(showOffer)
  }

  const dismissOfer = () => {
    setshowOffer(false)
  }

  return (
    <>
      {!ctaOfferIsDisabledOnWidget && link && linkText && offerText &&
        <Grid
          container
          className={`${classes.root} ${classes.typographyStyle} ${backgroundCTAOffer}`}
          justifyContent='center'
          alignContent='center'
          data-testid='cta-offer-container'
        >
          {
            offerText && link && linkText && !open &&
            <Typography
              className={`${classes.typography} ${classes.typographyStyle}`}
            >
              {offerText} <a className={classes.anchor} href={link} target="_blank">{linkText} <span className={classes.arrow} > {'>'}</span> </a>
            </Typography>
          }
          {
            dismissibleOffer && !open &&
            <Button
              disableRipple={true}
              classes={{ root: classes.rootButton }}
              className={classes.closeButton}
              onClick={() => handleClick(true)} >
              &times;
            </Button>
          }

          {dismissibleOffer && open &&
            <>
              <Typography className={`${classes.typographyHideOffer} ${classes.typographyStyle}`}>
                {translations.hideMessage}
              </Typography>
              <Button
                classes={{ root: classes.rootButton }}
                className={`${classes.hideButton} ${classes.typographyStyle}`}
                onClick={() => hideCtaOfferOnWidget()} >
                {translations.hideButton}
              </Button>
              <Button
                classes={{ root: classes.rootButton }}
                className={`${classes.cancelButton} ${classes.typographyStyle}`}
                onClick={() => handleClick(false)} >
                {translations.cancelButton}
              </Button>
            </>
          }
        </Grid>
      }
    </>
  )
}

export default compose(
  withComponentContext,
  withStyles(styles, { name: 'CTAOffer', withTheme: true, defaultTheme: getDefaultTheme }),
  withTranslations((t: TranslationFunction) => {
    return {
      hideMessage: t('hideMessage.translations', {
        defaultValue: 'Hide the offer?',
        context: 'label tab for hide message'
      }),
      hideButton: t('hideButton.translations', {
        defaultValue: 'Hide Offer',
        context: 'label buttom for hide message'
      }),
      cancelButton: t('cancelButton.translations', {
        defaultValue: 'Cancel',
        context: 'label buttom for calcen dismiss'
      })
    }
  })
)(CTAOffer)
